module.exports = __webpack_public_path__ + "img/member.4231c985.png";